import { PeriodComparisonListItem } from '@frontend/chart/components';

/** Highest absolute % movers in one direction for popularity-style lists. */
export const takeRankedPeriodComparisonItems = (items: PeriodComparisonListItem[], direction: 'up' | 'down', limit: number): PeriodComparisonListItem[] =>
    items
        .filter((item) => item.direction === direction && item.percentChange !== null)
        .sort((left, right) => (right.percentChange ?? 0) - (left.percentChange ?? 0))
        .slice(0, limit);
